import {
  createTextReducer as createCoreTextReducer,
  registerTranslation,
  setLocale
} from 'nucleus-widgets/redux/modules/text';

import { utcToDisplayDate } from './timezones';

const createTranslateWithTimezone = (translate, timezone) =>
  (value, ...args) => {
    return translate(utcToDisplayDate(value, timezone), ...args);
  };

/**
 * Creates a text reducer with the given context. The reducer is then augmented
 * to have the translateDate function alter the date to correctly display for
 * the event timezone.
 */
const createTextReducer = context => {
  const coreTextReducer = createCoreTextReducer(context, { enabled: true });
  const initialState = coreTextReducer(undefined, { });
  return (state = initialState, action, eventTimezone) => {
    const nextState = coreTextReducer(state, action);
    const textUpdates = nextState !== state;
    if (!textUpdates && state.eventTimezone === eventTimezone) {
      return state;
    }

    // If the core text resolver received no updates the un altered versions of the translate
    // methods.
    const translateDate = textUpdates ? nextState.translateDate : state.unAlteredTranslateDate;
    const translateTime = textUpdates ? nextState.translateTime : state.unAlteredTranslateTime;
    return {
      ...nextState,
      eventTimezone,
      unAlteredTranslateDate: translateDate,
      unAlteredTranslateTime: translateTime,
      translateDate: createTranslateWithTimezone(translateDate, eventTimezone),
      translateTime: createTranslateWithTimezone(translateTime, eventTimezone)
    };
  };
};

export default createTextReducer();
export { createTextReducer, setLocale, registerTranslation };
